export default __webpack_public_path__ + "static/media/coop-kurs.a278c956.jpg";